<template lang="pug">
.checkout-venta-center
  .loader-container(v-if="globalLoading")
    b-spinner(variant="primary" label="Cargando...")
  
  template(v-else-if="ot")
    .container-fluid.px-5.py-4
      // Alerta de conflicto de reserva
      b-alert(v-if="reservaCorrupta" show variant="warning" dismissible)
        b-icon-exclamation-triangle-fill.mr-2
        template(v-if="reservaConflicto && reservaConflicto.reservado_por")
          | Este equipo está siendo procesado por 
          strong {{ reservaConflicto.reservado_por }}.
          |  Por favor, espera que finalice o intenta con otra orden de trabajo.
        template(v-else)
          | Este equipo ya se encuentra reservado. Por favor, intenta con otra orden de trabajo.
      // Header Section (Breadcrumbs + Title)
      .header-section.mb-4
        .header-nav.d-flex.align-items-center.gap-2.mb-1
          b-icon-arrow-left-square-fill.back-arrow(@click="$router.go(-1)")
          h2.section-title.mb-0 Checkout Venta Directa
        b-breadcrumb.d-flex.justify-content-start(:items="breadcrumbItems")
      b-row
        // Columna Izquierda: Formulario
        b-col(lg="8")
          b-card.form-card.mb-3
            // Paso 1: Datos del Cliente
            .step-header.d-flex.align-items-center.mb-4
              .step-number 1
              h3.step-title Datos del Cliente
            
            b-row.mb-4
              b-col(md="6")
                b-form-group(label="RUT" label-class="font-weight-bold")
                  b-form-input(
                    v-model="form.rut"
                    placeholder="Ej: 12345678-9"
                    @blur="formatRut('rut')"
                    :state="getValidationState('rut')"
                  )
                  b-form-invalid-feedback El RUT es inválido.
            b-row.mb-4
              b-col(md="6")
                b-form-group(label="Nombre" label-class="font-weight-bold")
                  b-form-input(
                    v-model="form.nombre"
                    placeholder="Ingrese Nombres del Cliente"
                    :state="getValidationState('nombre')"
                  )
              b-col(md="6")
                b-form-group(label="Apelidos" label-class="font-weight-bold")
                  b-form-input(
                    v-model="form.apellido"
                    placeholder="Ingrese Apellidos del Cliente"
                    :state="getValidationState('apellido')"
                  )
            
            b-row.mb-5
              b-col(md="6")
                b-form-group(label="Correo Electrónico" label-class="font-weight-bold")
                  b-form-input(
                    v-model="form.email"
                    type="email"
                    placeholder="Ingrese Correo Cliente"
                    :state="getValidationState('email')"
                  )
              b-col(md="6")
                b-form-group(label="Teléfono" label-class="font-weight-bold")
                  b-form-input(
                    v-model="form.telefono"
                    placeholder="Ej: +56 9 1234 5678"
                    :state="getValidationState('telefono')"
                  )
            // Paso 2: Tipo de Documento
            .step-header.d-flex.align-items-center.mb-3
              .step-number 2
              h3.step-title Tipo de Documento
            
            .invoice-toggle.mb-4
              p.text-muted.small Seleccione esta opción si necesitas Factura
              .d-flex.align-items-center
                b-form-checkbox(v-model="requiereFactura" size="lg")
                  span.ml-2 Factura
            
            // Sección Factura (Condicional)
            b-collapse(v-model="requiereFactura")
              .invoice-fields.bg-light.p-3.rounded.mb-5
                b-row.mb-3
                  b-col(md="8")
                    b-form-group(label="RUT Contribuyente" label-class="font-weight-bold")
                      .d-flex.gap-2
                        b-form-input(
                          v-model="form.rut_contribuyente"
                          placeholder="96123456-3"
                          @blur="formatRut('rut_contribuyente')"
                          :state="getValidationState('rut_contribuyente')"
                        )
                        b-form-invalid-feedback El RUT es inválido.
                        b-button(
                          :variant="contribuyenteValidado ? 'danger' : (isValidRutContribuyente ? 'primary' : 'outline-secondary')"
                          @click="fetchContribuyenteAction"
                          :disabled="contribuyenteLoading || (!isValidRutContribuyente && !contribuyenteValidado)"
                        )
                          b-spinner(small v-if="contribuyenteLoading")
                          span(v-else) {{ contribuyenteValidado ? 'Limpiar' : 'Validar' }}
                    p.text-danger.small(v-if="contribuyenteError") {{ contribuyenteError }}
                
                b-row.mb-3(v-if="contribuyenteValidado")
                  b-col(md="12")
                    b-form-group(label="Razón Social" label-class="font-weight-bold")
                      b-form-input(v-model="form.razon_social" readonly disabled)
                
                b-row.mb-3(v-if="contribuyenteValidado")
                  b-col(md="12")
                    b-form-group(label="Giro" label-class="font-weight-bold")
                      b-form-select(
                        v-if="opcionesGiro.length > 1"
                        v-model="form.giro"
                        :options="opcionesGiro"
                      )
                      b-form-input(v-else v-model="form.giro" readonly disabled)
                b-row.mb-3(v-if="contribuyenteValidado")
                  b-col(md="12")
                    b-form-group(label="Dirección Tributaria" label-class="font-weight-bold")
                      b-form-select(
                        v-if="opcionesSucursal.length > 1"
                        :value="sucursalSeleccionadaIndex"
                        @change="onSucursalChange"
                      )
                        option(:value="null" disabled) Seleccione una dirección
                        option(
                          v-for="(op, i) in opcionesSucursal"
                          :key="i"
                          :value="i"
                        ) {{ op.label }}
                      b-form-input(v-else v-model="form.direccion_tributaria" readonly disabled)
                b-row.mb-3(v-if="contribuyenteValidado && form.comuna_tributaria")
                  b-col(md="12")
                    b-form-group(label="Comuna Tributaria" label-class="font-weight-bold")
                      b-form-input(v-model="form.comuna_tributaria" readonly disabled)
            // Paso 3: Garantía Extendida
            .step-header.d-flex.align-items-center.mb-3
              .step-number 3
              h3.step-title Garantía Extendida
            
            p.text-muted.small.mb-3 Protege tu equipo por más tiempo ante fallas de funcionamiento después de la garantía estándar.
            b-row.mb-4
              b-col(md="6")
                b-form-group(label="Tipo de Garantía" label-class="font-weight-bold")
                  b-form-select(
                    v-model="form.garantia_extendida_id"
                    :options="garantiaOptions"
                  )
                    template(#first)
                      b-form-select-option(:value="null") Selecciona una opción

        // Columna Derecha: Resumen
        b-col(lg="4")
          .d-flex.flex-column.right-column

            // --- Card Producto ---
            .product-card.mb-0
              h4.font-weight-bold.mb-1 Producto
              p.ot-label.mb-2 OT {{ ot.ot }}
              .d-flex.align-items-center(style="gap: 12px")
                .product-image-sm(v-if="equipoImagen")
                  img(:src="equipoImagen" alt="Producto")
                .flex-grow-1
                  p.small.text-muted.mb-1 {{ ot.equipo.modelo_detail.nombre_tienda || ot.equipo.modelo_detail.model_name }}
                  .d-flex.justify-content-between.align-items-center
                    span.small Cantidad 1
                    span.small.font-weight-bold.text-blue-accent {{ formatCurrency(ot.equipo.modelo_detail.precio_tienda) }}

            // --- Card Resumen ---
            .totals-card
              h4.font-weight-bold.mb-3 Resumen

              // Bloque de cupón
              .cupon-group.mb-1
                .d-flex(style="gap: 8px")
                  b-form-input.cupon-input(
                    v-model="codigoCupon"
                    placeholder="Código de Descuento"
                    :disabled="cuponLoading || tieneCuponAplicado"
                    :readonly="tieneCuponAplicado"
                    @keyup.enter="onToggleCupon"
                  )
                  b-button.btn-cupon(
                    variant="samtek-yellow"
                    @click="onToggleCupon"
                    :disabled="cuponLoading || (!tieneCuponAplicado && !codigoCupon.trim())"
                  )
                    b-spinner(small v-if="cuponLoading")
                    span(v-else) {{ tieneCuponAplicado ? 'Eliminar' : 'Aplicar' }}

              // Mensaje éxito (azul, 10px) — muestra el mensaje que devuelve el backend
              p.cupon-msg-success(v-if="tieneCuponAplicado") {{ cuponAplicado.mensaje }}
              // Mensaje error (rojo, 10px) — solo cuando hay error y no hay cupón
              p.cupon-msg-error(v-else-if="cuponError") {{ cuponError }}

              // Filas del resumen
              .d-flex.justify-content-between.mb-2.mt-2
                span.font-weight-bold Sub-Total:
                span {{ formatCurrency(subtotal) }}
              .d-flex.justify-content-between.mb-2
                span.font-weight-bold IVA:
                span {{ formatCurrency(iva) }}
              .d-flex.justify-content-between.mb-2(v-if="precioGarantia > 0")
                span.font-weight-bold Garantía Extendida:
                span {{ formatCurrency(precioGarantia) }}
              .d-flex.justify-content-between.mb-2(v-if="tieneCuponAplicado")
                span.font-weight-bold Descuento:
                span.descuento-value -{{ formatCurrency(descuentoCupon) }}

              hr

              .d-flex.justify-content-between.align-items-center.total-row.mb-3
                span TOTAL:
                span {{ formatCurrency(total) }}

              b-button.btn-pay.w-100(
                variant="samtek-yellow"
                @click="onVenta"
                :disabled="!isFormValid || loading"
              )
                b-spinner(small v-if="loading")
                span(v-else) Marcar como Pagado

  .error-container(v-else)
    b-alert(show variant="danger")
      h4 Error al cargar la Orden de Trabajo
      p No se pudo encontrar la información necesaria para realizar la venta.
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import validateRut from '@/utils/validateRut'

export default {
  name: 'CheckoutVentaCenter',
  data() {
    return {
      globalLoading: true,
      codigoCupon: '',
      form: {
        rut: '',
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        rut_contribuyente: '',
        razon_social: '',
        giro: '',
        direccion_tributaria: '',
        comuna_tributaria: '',
        garantia_extendida_id: null,
        tipo_documento: 1, // 1: Boleta, 2: Factura
      },
      requiereFactura: false,
      contribuyenteValidado: false,
      contribuyenteInfo: null,
      sucursalSeleccionadaIndex: null,
      breadcrumbItems: [
        { text: 'Inicio', to: { path: '/' } },
        { text: 'Trabajo en Curso', to: { path: '/listar-ordenes' } },
        {
          text: 'OT',
          to: {
            name: 'Orden de Trabajo',
            params: { order_id: this.$route.params.order_id },
          },
        },
        { text: 'Checkout Venta Directa', active: true },
      ],
      heartbeatTimer: null,
      sessionTimer: null,
    }
  },
  computed: {
    ...mapState('VentaCenterStore', [
      'loading',
      'error',
      'warranties',
      'contribuyente',
      'contribuyenteLoading',
      'contribuyenteError',
      'reservaCorrupta',
      'reservaConflicto',
      'cuponAplicado',
      'cuponLoading',
      'cuponError',
    ]),
    ...mapGetters('VentaCenterStore', [
      'tieneCuponAplicado',
      'porcentajeCupon',
    ]),
    ...mapGetters('OTStore', ['ot']),
    equipoImagen() {
      const imagenes = this.ot?.equipo?.modelo_detail?.imagenes
      if (imagenes && imagenes.length > 0) {
        const principal = imagenes.find((img) => img.is_principal)
        return (principal || imagenes[0]).imagen
      }
      return null
    },
    garantiaOptions() {
      return this.warranties.map((g) => ({
        value: g.id,
        text: `${g.nombre} ($${new Intl.NumberFormat('es-CL').format(
          g.precio
        )})`,
      }))
    },
    precioGarantia() {
      const selected = this.warranties.find(
        (g) => g.id === this.form.garantia_extendida_id
      )
      return selected ? selected.precio : 0
    },
    subtotal() {
      const precio = this.ot?.equipo?.modelo_detail?.precio_tienda || 0
      return Math.round(precio / 1.19)
    },
    iva() {
      const precio = this.ot?.equipo?.modelo_detail?.precio_tienda || 0
      return precio - this.subtotal
    },
    descuentoCupon() {
      // El descuento se aplica sobre el precio con IVA (precio_tienda)
      const precio = this.ot?.equipo?.modelo_detail?.precio_tienda || 0
      return this.$store.getters['VentaCenterStore/montoCupon'](precio)
    },
    total() {
      const precioEquipo = this.ot?.equipo?.modelo_detail?.precio_tienda || 0
      return precioEquipo + this.precioGarantia - this.descuentoCupon
    },
    isValidRut() {
      return validateRut(this.form.rut)
    },
    isValidRutContribuyente() {
      return this.form.rut_contribuyente
        ? validateRut(this.form.rut_contribuyente)
        : null
    },
    opcionesGiro() {
      const c = this.contribuyenteInfo || {}
      const acts = c.actividades || []
      const vistos = new Set()
      const lista = []
      acts.forEach((a) => {
        const key = a.actividadEconomica || a.giro
        if (!key || vistos.has(key)) return
        vistos.add(key)
        lista.push(key)
      })
      if (!lista.length && c.giro) lista.push(c.giro)
      return lista
    },
    opcionesSucursal() {
      const c = this.contribuyenteInfo || {}
      const sucs = c.sucursales || []
      const vistas = new Set()
      const lista = []
      sucs.forEach((s) => {
        if (!s.direccion) return
        const key = `${s.direccion}|${s.comuna || ''}`
        if (vistas.has(key)) return
        vistas.add(key)
        lista.push({
          label: s.direccion,
          direccion: s.direccion,
          comuna: s.comuna || '',
        })
      })
      return lista
    },
    isFormValid() {
      if (this.reservaCorrupta) return false
      const baseValid =
        this.isValidRut &&
        this.form.nombre &&
        this.form.apellido &&
        this.form.email &&
        this.form.telefono
      if (this.requiereFactura) {
        return (
          baseValid &&
          this.contribuyenteValidado &&
          this.form.rut_contribuyente &&
          this.form.razon_social &&
          this.form.giro &&
          this.form.direccion_tributaria &&
          this.form.comuna_tributaria
        )
      }
      return baseValid
    },
  },
  watch: {
    requiereFactura(val) {
      this.form.tipo_documento = val ? 2 : 1
      if (!val) this.resetInvoiceFields()
    },
    contribuyente(val) {
      if (val) {
        this.contribuyenteInfo = val
        this.form.razon_social = val.razon_social || ''
        const acts = val.actividades || []
        const principal = acts.find((a) => a.actividadPrincipal) || acts[0]
        this.form.giro =
          principal?.actividadEconomica || principal?.giro || val.giro || ''
        this.form.direccion_tributaria = val.direccion || ''
        this.form.comuna_tributaria = val.comuna || ''
        const idx = this.opcionesSucursal.findIndex(
          (s) =>
            s.direccion === this.form.direccion_tributaria &&
            s.comuna === this.form.comuna_tributaria
        )
        this.sucursalSeleccionadaIndex = idx >= 0 ? idx : null
        this.contribuyenteValidado = true
      }
    },
  },
  async created() {
    this.globalLoading = true
    try {
      const { order_id } = this.$route.params
      await this.getOT(order_id)
      if (this.ot) {
        const precio = this.ot.equipo?.modelo_detail?.precio_tienda || 0
        await this.fetchWarranties({
          precio,
          equipoId: this.ot.equipo.id,
        })
        await this.reservarEquipo({ order_id, equipo_id: this.ot.equipo.id })
        this.startHeartbeat()
        this.startSessionTimer()
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.globalLoading = false
    }
  },
  async beforeDestroy() {
    if (this.heartbeatTimer) clearInterval(this.heartbeatTimer)
    if (this.sessionTimer) clearTimeout(this.sessionTimer)
    // Limpiar cupón al salir para no dejar estado sucio
    this.resetCupon()
    if (this.ot) {
      await this.liberarEquipo({ equipo_id: this.ot.equipo.id })
    }
  },
  methods: {
    ...mapActions('OTStore', ['getOT']),
    ...mapActions('VentaCenterStore', [
      'reservarEquipo',
      'liberarEquipo',
      'fetchWarranties',
      'fetchContribuyente',
      'realizarVenta',
      'validarCupon',
      'resetCupon',
    ]),
    startHeartbeat() {
      this.heartbeatTimer = setInterval(async () => {
        if (this.ot?.equipo?.id) {
          await this.reservarEquipo({
            order_id: this.ot.ot,
            equipo_id: this.ot.equipo.id,
          })
        }
      }, 2.5 * 60 * 1000)
    },
    startSessionTimer() {
      this.sessionTimer = setTimeout(() => {
        this.handleSessionExpire()
      }, 30 * 60 * 1000)
    },
    async handleSessionExpire() {
      this.$bvToast.toast(
        'La sesión de venta ha expirado por inactividad. Serás redirigido.',
        {
          title: 'Sesión Expirada',
          variant: 'warning',
          solid: true,
        }
      )
      if (this.ot) {
        await this.liberarEquipo({ equipo_id: this.ot.equipo.id })
      }
      setTimeout(() => {
        this.$router.push({
          name: 'Orden de Trabajo',
          params: { order_id: this.$route.params.order_id },
        })
      }, 3000)
    },
    formatRut(field) {
      const rut = this.form[field].replace(/[^\dkK]/g, '')
      if (!rut) return
      const dv = rut.slice(-1)
      const num = rut.slice(0, -1)
      const formatted = `${num}-${dv}`
      this.form[field] = formatted.toUpperCase()
    },
    getValidationState(field) {
      if (!this.form[field]) return null
      if (field === 'rut') return this.isValidRut
      if (field === 'rut_contribuyente') return this.isValidRutContribuyente
      if (field === 'email')
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form[field])
      return this.form[field].length > 1
    },
    async fetchContribuyenteAction() {
      if (this.contribuyenteValidado) {
        this.resetInvoiceFields()
        return
      }
      await this.fetchContribuyente(this.form.rut_contribuyente)
    },
    resetInvoiceFields() {
      this.form.rut_contribuyente = ''
      this.form.razon_social = ''
      this.form.giro = ''
      this.form.direccion_tributaria = ''
      this.form.comuna_tributaria = ''
      this.contribuyenteValidado = false
      this.contribuyenteInfo = null
      this.sucursalSeleccionadaIndex = null
    },
    onSucursalChange(idx) {
      const op = this.opcionesSucursal[idx]
      if (op) {
        this.sucursalSeleccionadaIndex = idx
        this.form.direccion_tributaria = op.direccion
        this.form.comuna_tributaria = op.comuna
      }
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
      }).format(val)
    },
    /**
     * Botón toggle: si hay cupón aplicado lo elimina, si no lo valida.
     */
    async onToggleCupon() {
      if (this.tieneCuponAplicado) {
        this.resetCupon()
        this.codigoCupon = ''
        return
      }
      const codigo = this.codigoCupon.trim()
      if (!codigo) return
      await this.validarCupon(codigo)
      // Si se aplicó con éxito, limpiar el campo de texto
      if (this.tieneCuponAplicado) {
        this.codigoCupon = this.cuponAplicado.codigo
      }
    },
    async onVenta() {
      try {
        const payload = {
          ...this.form,
          equipo_id: this.ot.equipo.id,
        }
        // Solo incluir codigo_cupon si hay un cupón validado
        if (this.tieneCuponAplicado) {
          payload.codigo_cupon = this.cuponAplicado.codigo
        }
        await this.realizarVenta(payload)
        this.$bvToast.toast('Venta procesada exitosamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
        })
        this.$router.push({
          name: 'Orden de Trabajo',
          params: { order_id: this.ot.ot },
        })
      } catch (error) {
        const data = error.response?.data
        let msg = 'Error desconocido'
        if (data) {
          if (typeof data === 'string') {
            msg = data
          } else if (data.codigo_cupon) {
            msg = `Cupón inválido: ${
              Array.isArray(data.codigo_cupon)
                ? data.codigo_cupon.join(', ')
                : data.codigo_cupon
            }`
          } else {
            msg = JSON.stringify(data)
          }
        }
        this.$bvToast.toast(`No se pudo procesar la venta: ${msg}`, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/style/colors.scss';

.checkout-venta-center {
  background-color: #f5f6fa;
  min-height: calc(100vh - 70px);

  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
  }

  .header-section {
    margin-bottom: 1rem;

    .header-nav {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-bottom: 0.25rem;
    }

    .section-title {
      font-size: 20px;
      font-weight: bold;
      color: #23201c;
    }
  }

  .back-arrow {
    color: $samtek-yellow;
    background-color: #23201c;
    border-radius: 6px;
    font-size: 1.5rem;
    cursor: pointer;
  }

  .form-card {
    border: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 10px;
  }

  .step-header {
    .step-number {
      background-color: #fece2f;
      color: #23201c;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      margin-right: 15px;
      flex-shrink: 0;
    }
    .step-title {
      font-family: 'Noto Sans', sans-serif;
      font-weight: 700;
      font-size: 1.25rem;
      margin-bottom: 0;
    }
  }

  // Columna derecha: gap entre cards
  .right-column {
    gap: 16px;
  }

  // Card Producto (blanca)
  .product-card {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

    .ot-label {
      font-size: 15px;
      font-weight: 600;
      color: #23201c;
      margin-bottom: 0;
    }

    .product-image-sm {
      width: 68px;
      height: 68px;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  // Card Resumen (fondo amarillo translúcido)
  .totals-card {
    background-color: rgba(244, 194, 53, 0.1);
    border-radius: 10px;
    padding: 20px;

    // Bloque input cupón
    .cupon-group {
      .cupon-input {
        flex: 1;
        height: 45px;
        border: 1px solid #525252;
        border-radius: 5px;
        font-size: 15px;
        color: #23201c;
        background-color: #ffffff;
        // Estado disabled (cupón aplicado): fondo gris para indicar que no es editable
        &:disabled {
          background-color: #f0f0f0;
          color: #6c757d;
          border-color: #ced4da;
          cursor: not-allowed;
          opacity: 1;
        }
        // readonly sin disabled: mantiene apariencia normal
        &[readonly]:not(:disabled) {
          background-color: #ffffff;
          color: #23201c;
          opacity: 1;
        }
      }

      .btn-cupon {
        background-color: #fece2f;
        border: none;
        color: #23201c;
        font-weight: 500;
        height: 45px;
        border-radius: 8px;
        padding: 0 20px;
        white-space: nowrap;
        flex-shrink: 0;
        &:hover:not(:disabled) {
          background-color: darken(#fece2f, 5%);
        }
        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }

    // Mensaje éxito: azul #1D4ED8, 10px, Noto Sans Medium
    .cupon-msg-success {
      font-size: 10px;
      font-weight: 500;
      color: #1d4ed8;
      margin-bottom: 0;
      margin-top: 4px;
    }

    // Mensaje error: rojo #FF3838, 10px, Noto Sans Medium
    .cupon-msg-error {
      font-size: 10px;
      font-weight: 500;
      color: #ff3838;
      margin-bottom: 0;
      margin-top: 4px;
    }

    // Valor de descuento en la fila
    .descuento-value {
      color: #1d4ed8;
      font-weight: 500;
    }

    // Fila TOTAL — azul, 20px bold
    .total-row {
      color: #1d4ed8;
      font-size: 20px;
      font-weight: 700;
    }

    .btn-pay {
      background-color: #fece2f;
      border: none;
      color: #23201c;
      font-weight: 500;
      height: 45px;
      border-radius: 8px;
      &:hover:not(:disabled) {
        background-color: darken(#fece2f, 5%);
      }
      &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
      }
    }
  }

  .text-blue-accent {
    color: $blue-accent;
  }

  .gap-2 {
    gap: 0.5rem;
  }
  .gap-3 {
    gap: 0.75rem;
  }
}
</style>
